import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DebounceDirective } from './debounce.directive';



@NgModule({
  declarations: [DebounceDirective],
  imports: [
    CommonModule
  ],
  exports: [DebounceDirective]
})
export class DebounceModule { }
